import { useQuery } from "@tanstack/react-query";

import { api } from "@utils/api";

import { appointmentQKeys } from "./queryKeys";


export const useGetAppointmentNotifications = (appointmentId: string, enabled = true) => {
  return useQuery({
    queryKey: appointmentQKeys.notifications(appointmentId),
    queryFn: async () => {
      const res = await api.get(`appointments/${appointmentId}/notifications`);
      return res.data;
    },
    enabled: enabled && !!appointmentId,
  });
};